import { createAction, handleActions } from "redux-actions";

export const types = {
  apiStatus: "API_STATUS",
  apiRequestStart: "API_REQUEST_START",
  apiRequestEnd: "API_REQUEST_END",
  apiRequestError: "API_REQUEST_ERROR",
};

export const apiStatus = createAction(types.apiStatus);
export const apiRequestStart = createAction(types.apiRequestStart);
export const apiRequestEnd = createAction(types.apiRequestEnd);
export const apiRequestError = createAction(types.apiRequestError);

export const INITIAL_STATE = {
  connected: false,
  offline: "offline mode",
  error: "",
  requesting: false,
  requestError: "",
};

export const apiReducer = handleActions(
  {
    [types.apiStatus]: (state, action) => ({
      ...state,
      connected: action.payload.connected,
      offline: action.payload.offline,
      error: action.payload.error,
    }),
    [types.apiRequestStart]: (state) => ({
      ...state,
      requesting: true,
    }),
    [types.apiRequestEnd]: (state) => ({
      ...state,
      requesting: false,
    }),
    [types.apiRequestError]: (state, action) => ({
      ...state,
      requesting: false,
      requestError: action.payload.message,
    }),
  },
  INITIAL_STATE
);
